import React, { useState, useEffect, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom'; 
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
// import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
// import { db } from '../firebase-config';
import Slider from 'react-slick';
import Select from 'react-select';
import { subCategories } from '../utils/constants';
import './newsCard.css';
// --- 2. IMPORT THE SPECIFIC ICONS YOU NEED ---
import { 
    faThumbsUp, 
    faThumbsDown, 
    faShareAlt, 
    faBookmark, 
    faFilter,
    // faBan,
    faExclamationTriangle,
    faUserCircle,
    faComment
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Share } from '@capacitor/share';
import { getFirestore, doc, updateDoc, arrayUnion, arrayRemove, addDoc, collection, onSnapshot } from "firebase/firestore";
import { app } from '../firebase-config';
const db = getFirestore(app);

const formatNewsContent = (text) => {
    if (!text) return "";

    // Escape raw HTML first to prevent XSS injection
    let safeText = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    // Definition for allowed single characters + connected parts (e.g. word1/word2-word3)
    // Matches English alphanumeric, underscore, and the full Telugu Unicode block
    const wordPattern = '[a-zA-Z0-9_\\u0C00-\\u0C7F]+(?:[/\\-_|&][a-zA-Z0-9_\\u0C00-\\u0C7F]+)*';

    // 1. Highlight wrapped asterisks like *text* or *text/text*
    safeText = safeText.replace(/\*([^\*]+)\*/g, '<span class="highlight-starred">*$1*</span>');

    // 2. Highlight single words starting with * like *text (handles connected compound words)
    const starRegex = new RegExp(`(?:^|\\s)\\*(${wordPattern})`, 'g');
    safeText = safeText.replace(starRegex, (match) => {
        const wordMatch = match.match(new RegExp(`\\*(${wordPattern})`));
        return wordMatch ? match.replace(`*${wordMatch[1]}`, `<span class="highlight-starred">*${wordMatch[1]}</span>`) : match;
    });

    // 3. Highlight Hashtags (#word or #word/word)
    const hashtagRegex = new RegExp(`#(${wordPattern})`, 'g');
    safeText = safeText.replace(hashtagRegex, '<span class="highlight-hashtag">#$1</span>');

    // 4. Highlight Mentions (@word or @word/word)
    const mentionRegex = new RegExp(`@(${wordPattern})`, 'g');
    safeText = safeText.replace(mentionRegex, '<span class="highlight-mention">@$1</span>');

    // 5. Highlight text inside angle brackets like <అలర్ట్> or <alert>
    // Since we escaped '<' and '>', we look for '&lt;' and '&gt;'
    safeText = safeText.replace(/&lt;([^&<\n]+)&gt;/g, '<span class="highlight-angle-bracket">&lt;$1&gt;</span>');

    // 6. Convert newlines to HTML breaks
    safeText = safeText.replace(/\n/g, '<br/>');

    return safeText;
};

const NewsCard = ({
    newsItem,
    onUpdate,
    isFeedView = true,
    isActive,
    onReportSuccess,
    onImageOpen,
    pageFilters = {}, // Default to an empty object
    setPageFilters = () => {}, // Default to an empty function
    activeFilterCardId,
    setActiveFilterCardId,
    setActiveCommentPostId
}) => {
    const [localNewsItem, setLocalNewsItem] = useState(newsItem);
    // useEffect(() => {
    //     setLocalNewsItem(newsItem);
    // }, [newsItem]);
    const { currentUser, firebaseUser } = useAuth();
    const [isSaving, setIsSaving] = useState(false);
    const [showReportOptions, setShowReportOptions] = useState(false);
    const [reportReason, setReportReason] = useState('');
    const [customReportText, setCustomReportText] = useState('');
    const [reportSubmitted, setReportSubmitted] = useState(false); // To show success message
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const imageCount = localNewsItem.imageUrls?.length || 0;
    const [showFullImage, setShowFullImage] = useState(false);
    const isMultiImage = imageCount > 1;
    const [sliderKey, setSliderKey] = useState(0); // 💡 NEW: State to force re-render
    // ADDED: Base URL for your app for deep linking and web fallbacks
    // Make sure this matches your deployed web app URL (Firebase Hosting, etc.)
    const APP_BASE_URL = 'https://inewsbook-1402f.web.app'; // <--- IMPORTANT: Update with your actual Firebase Hosting URL or custom domain
    // const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    // const togglePreview = (e) => {
    //     if (e) e.stopPropagation();
    //     setIsPreviewOpen(!isPreviewOpen);
    // };
    const videoRef = useRef(null);

    const navigate = useNavigate();

    // Inside NewsCard.js
    useEffect(() => {
        setLocalNewsItem(newsItem);
    }, [newsItem]); // This triggers an update whenever the post data changes

    const lastOpenTimeRef = useRef(0);

    const openFullImage = (e) => {
    if (e) {
        e.stopPropagation();
        if (typeof e.preventDefault === 'function') e.preventDefault();
    }
    const imageUrl = localNewsItem.imageUrls?.[currentImageIndex];
    if (!imageUrl) return;
    // Fire a global custom event - bypasses Swiper stacking context completely
    const event = new CustomEvent('openFullImage', { detail: { url: imageUrl } });
    window.dispatchEvent(event);
};

     // Add this useEffect to debug if userId is missing
    useEffect(() => {
        if (!newsItem.userId) {
            console.warn(`NewsCard for item ID ${newsItem.id} is missing userId. Author details in reports may be affected.`);
            // You might want to try to fetch userId here if it's missing,
            // or ensure it's provided when NewsCard is rendered.
            // Example: If newsItem.authorId is used instead, update below.
        }
    }, [newsItem.id, newsItem.userId]);
    // 💡 NEW: useEffect to trigger re-render after mounting
    useEffect(() => {
        const loadImages = () => {
            const urls = localNewsItem.imageUrls || [];
            if (urls.length <= 1) {
                setImagesLoaded(true); // Always true for 0 or 1 image
                return;
            }

            let loadedCount = 0;
            urls.forEach(url => {
                const img = new Image();
                img.onload = () => {
                    loadedCount++;
                    if (loadedCount === urls.length) {
                        // All images are in browser cache now
                        setImagesLoaded(true); 
                        // Now trigger the slider key trick immediately
                        setTimeout(() => setSliderKey(prev => prev + 1), 50); 
                    }
                };
                img.onerror = () => {
                    console.error(`[ERROR] Image failed to load during pre-fetch: ${url}`);
                    loadedCount++;
                    if (loadedCount === urls.length) {
                        setImagesLoaded(true); // Still allow the slider to show if some fail
                        setTimeout(() => setSliderKey(prev => prev + 1), 50);
                    }
                };
                img.src = url; // Start the loading
            });
        };

        loadImages();
    }, [localNewsItem.imageUrls]);
    // 💡 NEW: Manual Slider Handlers (for dots/auto-play logic if needed)
    useEffect(() => {
        if (!isMultiImage) return;

        const interval = setInterval(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % imageCount);
        }, 3000); // Auto-play every 3 seconds

        return () => clearInterval(interval);
    }, [isMultiImage, imageCount]);

    useEffect(() => {
    // If there's no video, do nothing
    if (!localNewsItem.videoUrl || !videoRef.current) return;
    // 💡 1. SWIPER ACTIVE STATE CONTROL (Primary)
    // If isActive is passed by Swiper, use it directly to avoid the stacked 3D element intersection bug
    if (typeof isActive !== 'undefined') {
        if (isActive) {
            videoRef.current.play().catch(error => {
                console.log("Autoplay prevented:", error);
            });
        } else {
            videoRef.current.pause();
        }
        return; // Exit and skip setting up the IntersectionObserver
    }
    // 💡 2. INTERSECTION OBSERVER CONTROL (Fallback)
    // Only runs if the card is loaded outside Swiper (e.g., a detail view or non-swiper page)
    const options = {
        root: null, // use the viewport
        threshold: 0.6 // 60% of the video must be visible to play
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Play video when it enters view
                videoRef.current.play().catch(error => {
                    // Autoplay might still be blocked by some browsers if not muted
                    console.log("Autoplay prevented:", error);
                });
            } else {
                // Pause video when it leaves view
                videoRef.current.pause();
            }
        });
    }, options);

    observer.observe(videoRef.current);

    // Clean up observer on unmount
    return () => {
        if (videoRef.current) {
            observer.unobserve(videoRef.current);
        }
    };
}, [isActive, localNewsItem.videoUrl]); // Re-run if video URL changes

    useEffect(() => {
    if (!localNewsItem?.id) return;

    const postRef = doc(db, 'userNews', localNewsItem.id);
    const unsubscribe = onSnapshot(postRef, (docSnap) => {
        if (docSnap.exists()) {
            const freshData = { id: docSnap.id, ...docSnap.data() };
            setLocalNewsItem(prev => ({
                ...prev,
                ...freshData
            }));
        }
    }, (error) => {
        console.error("Error syncing real-time updates for newsCard:", error);
    });

    return () => unsubscribe();
}, [localNewsItem.id]);

    // Memoize derived states for performance
    const hasLiked = useMemo(() => currentUser && localNewsItem.likedBy?.includes(currentUser.uid), [currentUser, localNewsItem.likedBy]);
    const hasDisliked = useMemo(() => currentUser && localNewsItem.dislikedBy?.includes(currentUser.uid), [currentUser, localNewsItem.dislikedBy]);
    const hasSaved = useMemo(() => currentUser && localNewsItem.savedBy?.includes(currentUser.uid), [currentUser, localNewsItem.savedBy]);

    // --- THE MAIN FIX IS HERE ---
    // We are now checking against an array of possible post types that should have filters.
    // This is much more flexible than using ||.
    const validPostTypesForFilters = ['World', 'India', 'AP', 'TS', 'Andhra Pradesh', 'Telangana'];
    const shouldRenderFilters = localNewsItem.postType && localNewsItem.postType.some(
    type => validPostTypesForFilters.includes(type)
    );

    const categoryOptions = newsItem.availableCategories || [];
    const selectedCategoryOption = categoryOptions.find(
        option => option.value === pageFilters.subCategory?.value
    );

    const handleActionClick = (e, action) => {
        e.stopPropagation();
        // If an action function is passed, call it
        if (action) action();
    };

    const handleLikeDislike = async (action) => {
        if (!firebaseUser) { alert("Please log in to react."); return; }

        // 1. Optimistic UI Update: Update the local state IMMEDIATELY
        const originalItem = { ...localNewsItem }; // Save the original state
        let updatedItem = { ...localNewsItem };
        const userId = firebaseUser.uid;

        if (action === 'like') {
            const hasLiked = updatedItem.likedBy.includes(userId);
            updatedItem.likedBy = hasLiked ? updatedItem.likedBy.filter(id => id !== userId) : [...updatedItem.likedBy, userId];
            updatedItem.dislikedBy = updatedItem.dislikedBy.filter(id => id !== userId); // Remove from dislikes
        } else if (action === 'dislike') {
            const hasDisliked = updatedItem.dislikedBy.includes(userId);
            updatedItem.dislikedBy = hasDisliked ? updatedItem.dislikedBy.filter(id => id !== userId) : [...updatedItem.dislikedBy, userId];
            updatedItem.likedBy = updatedItem.likedBy.filter(id => id !== userId); // Remove from likes
        }
        setLocalNewsItem(updatedItem); // This update is instant

        // 2. Backend Call
        try {
             // CRITICAL FIX: Use firebaseUser.getIdToken() directly
            const idToken = await firebaseUser.getIdToken(true);
            await axios.post(`https://api-5iacy4tfya-uc.a.run.app/user-news/${localNewsItem.id}/action`,
              { action: action },
              { headers: { Authorization: `Bearer ${idToken}` } }
            );
            // Success! The UI is already correct.
        } catch (error) {
            console.error(`Failed to ${action} post:`, error);
            // 3. Revert on Failure
            setLocalNewsItem(originalItem); // If the server fails, go back to the original state
            alert("Action failed. Please try again.");
        }
    };

    // Change the click handler:
    const handleCommentClick = (e) => {
        e.stopPropagation();
        if (typeof setActiveCommentPostId === 'function') {
            setActiveCommentPostId(localNewsItem.id);
        } else {
            console.error("setActiveCommentPostId is not a function. Check the relay chain!");
        }
    };

    const handleSave = async () => {
        if (!firebaseUser || isSaving) { // Use firebaseUser for authentication checks
            if (!firebaseUser) alert('Please log in to save posts.');
            return;
        }
        setIsSaving(true);
        const userRef = doc(db, 'users', firebaseUser.uid);
        const newsRef = doc(db, 'userNews', localNewsItem.id);
        try {
            if (hasSaved) {
                await updateDoc(userRef, { savedPosts: arrayRemove(localNewsItem.id) });
                await updateDoc(newsRef, { savedBy: arrayRemove(firebaseUser.uid) }); // Use firebaseUser.uid
                setLocalNewsItem(prev => ({ ...prev, savedBy: prev.savedBy.filter(id => id !== firebaseUser.uid) })); // Use firebaseUser.uid
            } else {
                await updateDoc(userRef, { savedPosts: arrayUnion(localNewsItem.id) });
                await updateDoc(newsRef, { savedBy: arrayUnion(firebaseUser.uid) }); // Use firebaseUser.uid
                setLocalNewsItem(prev => ({ ...prev, savedBy: [...(prev.savedBy || []), firebaseUser.uid] })); // Use firebaseUser.uid
            }
        } catch (error) {
            console.error("Error saving post:", error);
        } finally {
            setIsSaving(false);
        }
    };

//     const generateShareLink = (postId) => {
//     // Replace 'yourdomain.com' with your actual domain
//     // This MUST match what you configure for Universal/App Links
//     return `https://inewsbook-1402f.web.app/post/${postId}`;
// };

    const handleShare = async () => {
        // Construct the deep link URL. This path should be unique to a news item.
        // For web, this will open the web page. For native, it will trigger the deep link.
        const shareUrl = `https://ainewsapp.net/post/${localNewsItem.id}`;
        // Get the author name
        const author = localNewsItem.userName || localNewsItem.authorName || 'Ai News Reporter';

        const shareData = {
            title: `Ai News: ${localNewsItem.title}`,
            text: `📰 ${localNewsItem.title}\n✍️ Reported By: ${author}\n\nచదవండి Ai News App లో:`,
            url: shareUrl,
            dialogTitle: 'Share this News',
        };

        try {
            // Try to use the Capacitor Share plugin (for native app)
            await Share.share(shareData);
        } catch (error) {
            // Fallback to Web Share API for PWAs/web browsers
            console.log("Capacitor share failed, falling back to Web Share API:", error);
            if (navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    console.error('Web Share API failed:', err);
                    // Final fallback: copy link to clipboard
                    navigator.clipboard.writeText(shareData.url);
                    alert('Link copied to clipboard!');
                }
            } else {
                // Older desktop browsers: copy link to clipboard
                navigator.clipboard.writeText(shareData.url);
                alert('Link copied to clipboard!');
            }
        }
    };

    const reportReasons = [
        "Fake news",
        "Mistakes in news",
        "Wrong or Bad words in the news",
        "Unfair/Biased Story",
        "Repeated Story"
    ];

    const handleReportClick = () => {
        setShowReportOptions(prev => !prev);
        setReportReason(''); // Reset reason when opening/closing
        setCustomReportText('');
        setReportSubmitted(false);
    };

    const handleSubmitReport = async () => {
    if (!reportReason && !customReportText) {
        alert("Please select a reason or enter your issue.");
        return;
    }
    if (reportReason === 'Other' && !customReportText.trim()) {
            alert('Please provide details for your custom report.');
            return;
        }

    // IMPORTANT: Ensure postAuthorId has a value. If newsItem.userId is undefined, use null or a default.
    const authorId = newsItem.userId || null; // Use null if newsItem.userId is undefined/falsy

    if (authorId === null) {
        // You might want to handle this case more explicitly,
        // e.g., prevent reporting if author ID is essential,
        // or just proceed with a null author ID if that's acceptable for your data model.
        console.warn("Reporting a news item without a valid author ID.");
        // alert("Cannot report this item as author information is missing.");
        // return; // Uncomment this line if you want to disallow reporting items without an author ID
    }
    const reporterId = firebaseUser ? firebaseUser.uid : 'anonymous';
    const reporterEmail = firebaseUser && firebaseUser.email ? firebaseUser.email : 'N/A';
    const reporterName = currentUser && currentUser.profile?.name ? currentUser.profile.name : 'Anonymous';
    const reporterMobile = currentUser && currentUser.profile?.phoneNumber ? currentUser.profile.phoneNumber : 'N/A';

    const reportData = {
        postId: newsItem.id || 'N/A',
        reporterId: reporterId,
        reporterName: reporterName,
        reporterEmail: reporterEmail,
        reporterMobile: reporterMobile,

        reason: reportReason || 'Other',
        customText: customReportText.trim(),
        reportedAt: new Date(),
        postTitle: newsItem.title || 'N/A',

    // CRITICAL for Author Info: Make these fallback to 'N/A' if newsItem data is missing
    // We expect newsItem.userId to be the author's UID. If it's literally "unknown_author"
    // from your userNews collection, then it will be passed through here.
        postAuthorId: newsItem.userId && newsItem.userId !== 'unknown_author' ? newsItem.userId : 'N/A', // IMPORTANT check
        postAuthorName: newsItem.userName || 'N/A',
        postAuthorMobile: newsItem.userContact || 'N/A',
    // postAuthorEmail: newsItem.userEmail || 'N/A', // If you ever add this to newsItem
        status: 'pending',
    };

    try {
    // CRITICAL FIX: Add a console log to see if the user is authenticated at the moment of report
        if (!firebaseUser) {
            console.warn("User is not authenticated. Submitting report as 'anonymous'.");
            alert("Failed to submit report. Please login and try again.");
        }
        await addDoc(collection(db, 'reports'), reportData);
        setReportSubmitted(true);
        if (onReportSuccess) {
            onReportSuccess(newsItem.id);
        }
    } catch (error) {
        console.error("Error submitting report:", error);
        alert("Failed to submit report. Please try again.");
    }
    };

    // Safe multi-format timestamp parser
    const parseTimestamp = (timestamp) => {
        if (!timestamp) return null;
        
        // 1. If it's a standard client SDK Firestore Timestamp
        if (typeof timestamp.toDate === 'function') {
            return timestamp.toDate();
        }
        
        // 2. If it's a plain JSON object from a REST API
        if (typeof timestamp === 'object') {
            if (typeof timestamp._seconds === 'number') {
                return new Date(timestamp._seconds * 1000);
            }
            if (typeof timestamp.seconds === 'number') {
                return new Date(timestamp.seconds * 1000);
            }
        }
        
        // 3. If it's an ISO string or standard millisecond number
        const parsedDate = new Date(timestamp);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
    };

    const formatDate = (timestamp) => {
        const date = parseTimestamp(timestamp);
        if (!date) return 'Just now';
        
        return date.toLocaleDateString('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric'
        });
    };

    const getRelativeTime = (timestamp) => {
        const date = parseTimestamp(timestamp);
        if (!date) return "";

        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) return "just now";
        
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
        
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hr ago`;
        
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) return `${diffInDays} d ago`;

        // Fallback to actual date if older than a week
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    };

    const sliderSettings = {
        dots: true, infinite: true, speed: 500, slidesToShow: 1,
        slidesToScroll: 1, arrows: true, autoplay: true, autoplaySpeed: 3000,
    };

    if (!localNewsItem || !localNewsItem.id) {
        return <div className="news-card-placeholder">Loading...</div>;
    }

    // Determine if filters should be rendered at all for this card type
    // const shouldRenderFilters = localNewsItem.postType === 'India' || localNewsItem.postType === 'State News';

    const handleToggleFilters = () => {
        if (isFeedView && shouldRenderFilters) {
            setActiveFilterCardId(prevId => (prevId === localNewsItem.id ? null : localNewsItem.id));
        }
    };

    return (
        <div className="news-card-container">
            {/* Inline Portal prevents unmounting conflicts during rapid re-renders */}
            {/* <div className="news-card" onClick={handleToggleFilterSheet}> */}
                <div className="news-card">
                {/* 1. IMAGE & OVERLAYS SECTION */}
                <div
    className="news-image-slider"
    onClick={(e) => {
        if (!localNewsItem.videoUrl) {
            e.stopPropagation();
            const url = localNewsItem.imageUrls?.[currentImageIndex];
            if (url && typeof onImageOpen === 'function') {
                onImageOpen(url);
            }
        }
    }}
>
    {/* --- 1. MEDIA LOGIC: VIDEO OR IMAGES --- */}
    {localNewsItem.videoUrl ? (
    <video 
        ref={videoRef}
        key={localNewsItem.videoUrl}
        src={localNewsItem.videoUrl} 
        className="news-card-image" 
        controls 
        playsInline
        loop
        // Restricts inactive cards from loading heavy video streams over the network
        preload={isActive ? "auto" : "none"}
        onClick={(e) => e.stopPropagation()} 
    />
                                
) : localNewsItem.imageUrls && localNewsItem.imageUrls.length > 0 ? (
    <img 
        src={localNewsItem.imageUrls[currentImageIndex]} 
        alt={localNewsItem.title} 
        className="news-card-image" 
        onError={(e) => { e.target.onerror = null; e.target.src = '/placeholder-image.png'; }}
        decoding="async" // Offloads image decoding from the main UI thread
        loading={isActive ? "eager" : "lazy"} // Prioritizes loading of the active card
    />
) : (
    <div className="image-container placeholder">NO MEDIA</div>
)}
    
    {/* --- 2. MANUAL DOTS: ONLY SHOW FOR MULTI-IMAGE (NOT VIDEO) --- */}
    {isMultiImage && !localNewsItem.videoUrl && (
        <div className="manual-slider-dots">
            {localNewsItem.imageUrls.map((_, index) => (
                <span 
                    key={index} 
                    className={`manual-dot ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(index); }}
                />
            ))}
        </div>
    )}

                        {/* Brand Logo Overlay */}
                        <div className="news-card-brand-header is-overlay">
                            <img src="/images/logo.png" alt="Logo" className="brand-logo" />
                            {/* <span className="brand-name">
                                Ai News - ప్రజల వేదిక.! ప్రజల వార్త.!
                            </span> */}
                        </div>

                        {/* Context Info Overlay */}
                        <div className="news-context-row is-overlay">
                            <span className="context-location">
                                {(localNewsItem.postType?.[0] === 'Andhra Pradesh' && 'AP') ||
                                (localNewsItem.postType?.[0] === 'Telangana' && 'TS') ||
                                (localNewsItem.postType?.[0] === 'World' && 'World') ||
                                localNewsItem.postType?.[0] || 'General'}
                            </span>

                            {/* <span className="context-separator">•</span> */}

                            <span className="context-category">
                                {localNewsItem.subCategory?.[0] || 'News'}
                            </span>

                            {/* <span className="context-separator">•</span> */}

                            <span className="context-date">
                                {formatDate(localNewsItem.timestamp)}
                            </span>
                        </div>
                    </div>

                {/* 2. SCROLLABLE CONTENT SECTION */}
                <div className="news-card-content-wrapper">
                    {/* --- NEW: AUTHOR PROFILE HEADER --- */}
                    <div className="news-author-header">
                        <div className="author-info-left">
                            <FontAwesomeIcon icon={faUserCircle} className="author-icon" />
                            <span className="author-name" style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                {localNewsItem.userId ? (
                                    <Link 
                                        to={`/user/${localNewsItem.userId}`} 
                                        className="news-card-author-link"
                                        style={{ 
                                            textDecoration: 'none', 
                                            color: '#007bff', /* Standout link blue */
                                            fontWeight: '700',
                                            display: 'inline-flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {localNewsItem.userName || localNewsItem.authorName || 'Ai News Reporter'}
                                        
                                        {/* Actionable interactive badge */}
                                        <span className="profile-follow-badge" style={{
                                            marginLeft: '8px',
                                            padding: '2px 8px',
                                            fontSize: '10px',
                                            backgroundColor: '#e6f2ff',
                                            color: '#007bff',
                                            borderRadius: '12px',
                                            fontWeight: '600',
                                            border: '1px solid #b3d7ff',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '3px'
                                        }}>
                                            ప్రొఫైల్ / ఫాలో 👥
                                        </span>
                                    </Link>
                                ) : (
                                    <span style={{ fontWeight: '700', color: '#555' }}>
                                        {localNewsItem.userName || localNewsItem.authorName || 'Ai News Reporter'}
                                    </span>
                                )}
                            </span>
                        </div>
    
                        {/* Pushed to the far right corner */}
                        <span className="post-relative-time">
                            {getRelativeTime(localNewsItem.timestamp)}
                        </span>
                    </div>
                    <h3 
                        className="news-card-title"
                        dangerouslySetInnerHTML={{ __html: formatNewsContent(localNewsItem.title) }}
                    />
                    <div 
                        className="news-card-description"
                        dangerouslySetInnerHTML={{ __html: formatNewsContent(localNewsItem.content) }}
                    />

                </div>

                {/* 3. FIXED BOTTOM ACTIONS SECTION */}
                <div className="news-card-actions" onClick={(e) => e.stopPropagation()}>
                    <button className={`action-item ${hasLiked ? 'active' : ''}`} onClick={() => handleLikeDislike('like')}>
                        <FontAwesomeIcon icon={faThumbsUp} /> <span>{Array.isArray(localNewsItem.likedBy) ? localNewsItem.likedBy.length : 0}</span>
                    </button>
                    <button className={`action-item ${hasDisliked ? 'active' : ''}`} onClick={() => handleLikeDislike('dislike')}>
                        <FontAwesomeIcon icon={faThumbsDown} /> <span>{Array.isArray(localNewsItem.dislikedBy) ? localNewsItem.dislikedBy.length : 0}</span>
                    </button>
                    {/* --- NEW COMMENT BUTTON --- */}
                    <button className="action-item" onClick={handleCommentClick}>
                        <FontAwesomeIcon icon={faComment} /> 
                        <span>{localNewsItem.comments?.length || 0}</span>
                    </button>
            {/* <div className="report-action"> */}
                    <div className="report-action-wrapper"> {/* Add this wrapper */}
        <button onClick={handleReportClick} className="action-item">
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <span>Report</span>
        </button>

        {/* The Report Modal will be rendered conditionally here */}
        {showReportOptions && (
            // Remove the .report-modal-overlay here. We'll use a different approach.
            // The modal content itself will be positioned.
            <div className="report-modal-popover" onClick={(e) => e.stopPropagation()}>
                <h3>Help us to improve better:</h3>
                {reportSubmitted ? (
                    <p className="success-message">Report submitted! Thank you for your feedback.</p>
                ) : (
                    <>
                        <div className="report-reasons-list">
                            {reportReasons.map((reason, index) => (
                                <label key={index} className="report-radio-label">
                                    <input
                                        type="radio"
                                        name="reportReason"
                                        value={reason}
                                        checked={reportReason === reason}
                                        onChange={(e) => {
                                            setReportReason(e.target.value);
                                            setCustomReportText('');
                                        }}
                                    />
                                    {reason}
                                </label>
                            ))}
                            <label className="report-radio-label">
                                <input
                                    type="radio"
                                    name="reportReason"
                                    value="Other"
                                    checked={reportReason === 'Other'}
                                    onChange={(e) => setReportReason(e.target.value)}
                                />
                                Other (please specify)
                            </label>
                        </div>
                        {reportReason === 'Other' && (
                            <textarea
                                placeholder="Enter your issue here..."
                                value={customReportText}
                                onChange={(e) => setCustomReportText(e.target.value)}
                                className="report-textarea"
                                rows="3"
                            />
                        )}
                        <div className="modal-actions">
                            <button onClick={handleSubmitReport} className="submit-report-button" disabled={!reportReason && !customReportText}>
                                Submit
                            </button>
                            <button onClick={() => setShowReportOptions(false)} className="cancel-report-button">
                                Cancel
                            </button>
                        </div>
                    </>
                )}
            </div>
        )}
    </div> {/* End of report-action-wrapper */}

    <button onClick={() => handleShare(newsItem)} className="action-item">
        <FontAwesomeIcon icon={faShareAlt} />
        <span>Share</span>
                    {/* Share icon SVG */}
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></svg> */}
                </button>
            <button onClick={handleSave} className={`action-item ${hasSaved ? 'active' : ''}`} disabled={isSaving}>
                <FontAwesomeIcon icon={faBookmark} /> <span>{hasSaved ? 'Saved' : 'Save'}</span>
            </button>

    {isFeedView && shouldRenderFilters && (
        <button className="filter-button" onClick={handleToggleFilters}>
            {/* <FontAwesomeIcon icon={faFilter} /> */}
        </button>
    )}
</div>
        </div>
    </div>
    );
};

export default NewsCard;